import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../../diccionarios/comisionesModulo';
import { HabilitarPeriodoDeComisionesService } from '../../services/habilitar-periodo-de-comisiones.service';
import { CatalogoIndicadoresService } from '../../services/catalogo-indicadores.service';
import { AltaDeVendedoresService } from '../../services/alta-de-vendedores.service';
import { TipoDeVendedorService } from '../../services/tipo-de-vendedor.service';


@Component({
  selector: 'app-habilitar-periodo-de-comisiones',
  templateUrl: './habilitar-periodo-de-comisiones.component.html',
  styleUrls: ['./habilitar-periodo-de-comisiones.component.css']
})
export class HabilitarPeriodoDeComisionesComponent2 implements OnInit {

  tituloCard: string = 'Habilitar Periodo de Comisiones';
  tituloForm: string = 'Lista De Habilitar Periodo de Comisiones';

  formulario: FormGroup;

  mostrarFormulario: boolean = false;
  editableForm: boolean = false;

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;
  textoBuscar: string;

  //componentes para apuntar a diccionario
  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;

  textBoton: string;

  //para cargar con el grid
  listaVacia: boolean = true;
  loading: boolean = false;
  modulo: any = {};
  GUARDAR: string = 'guardar';

  cmbEstados: any[] = [
    {
      clave: 'ACTIVO',
      valor: 'ACTIVO'
    },
    {
      clave: 'INACTIVO',
      valor: 'INACTIVO'
    },
  ];

  cmbMeses: { clave: number; valor: string; }[];

  constructor(
    private fb: FormBuilder,
    private commonFormService: CommonFormService,
    private _utils: UtilsService,
    private _catalogo: CatalogoIndicadoresService,
    private _altaDeVendedor: AltaDeVendedoresService,
    private _serviciosCRUD: HabilitarPeriodoDeComisionesService,
    private _tipoDeVendedor: TipoDeVendedorService,
  ) { }

  ngOnInit() {
    this.modulo = comisionesModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;

    this.formulario = this.fb.group({
      idLiquidacion: ['', []],
      anio: ['', []],
      mes: ['', []],
      tipoVendedorId: ['', []],
      vendedorId: ['', []],
      totalTipoLiquida: ['', []],
      totalEmplLiquida: ['', []],
      totalPagoLiquida: ['', []],
      estadoProceso: ['', []],
      estadoCierre: ['', []],
      usuario: ['', []],
      fechaProceso: ['', []],
      fechaRevision: ['', []],
      estado: ['', []],
      tipoLiquidacion: ['', []],
      lsUnidadNegocio: ['', []],
      lsTipoVendedorId: ['', []],
      fechaInicio: ['', []],
      fechaFin: ['', []],
      mesFin: ['', []],
      motivoRevision: ['', []],
      mesDescripcion: ['', []],
      mesFinDescripcion: ['', []],
      tipoVendedorDescripcion: ['', []],
      nombreVendedor: ['', []],
      sueldoVariable: ['', []],
      excepcionSueldo: ['', []],
    });

    this.cargarGridcomponent();
    this.getTiposDeVendedores();
    this.getTodo();
    this.cmbMeses = this._catalogo.catalogoMeses();

    this.formulario.get("mes").disable();
    this.formulario.get("vendedorId").disable();
    this.formulario.get("tipoVendedorId").disable();

  }

  /* FUNCIONES */
  getTodo() {

    this.listaVacia = true;
    this.loading = true;

    this._serviciosCRUD.getTodo().subscribe((res: any[]) => {
      console.log("getTodo()", res)

      let filtradas = res.filter(p => p.estadoCierre === "CERRADO");

      for (let i = 0; i < filtradas.length; i++) {
        if (filtradas[i].lsTipoVendedorId.length > 1) {
          filtradas[i].tipoVendedorDescripcion = "TODOS";
        }
        else {
          this._tipoDeVendedor.getTipoDeVendedoreByID(filtradas[i].tipoVendedorId).subscribe((res: any) => {
            filtradas[i].tipoVendedorDescripcion = res.descripcion;
          });
        }
      }

      this.listaVacia = (filtradas.length === 0) ? true : false;
      this.rowData = filtradas;
      this.loading = false;

    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this.rowData = [];
    });

  }

  cargarGridcomponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.columnDefs = [
      {
        headerName: 'Id',
        field: 'idLiquidacion',
        filter: true,
        sortable: true,
        // width: 120,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Mes',
        field: 'mesDescripcion',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Año',
        field: 'anio',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Tipo Vendedor',
        field: 'tipoVendedorDescripcion',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Estado Proceso',
        field: 'estadoProceso',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Estado Cierre',
        field: 'estadoCierre',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.ver,
          colorBoton: this.DAT_BTNCSS.warning
        }
      },
      // {
      //   headerName: '',
      //   cellRenderer: 'buttonRenderer',
      //   width: 150,
      //   cellRendererParams: {
      //     onClick: this.eliminar.bind(this),
      //     label: this.DAT_BTNS.eliminar,
      //     colorBoton: this.DAT_BTNCSS.danger
      //   }
      // },
    ];

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();

  }

  nuevo() {
    this.formulario.reset();
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.textBoton = this.DAT_BTNS.guardar;
    this.tituloForm = 'Procesamiento Mensual De Liquidación de Comisiones';

    let userData = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    console.log("userData", userData)
    this.formulario.get('usuarioCarga').setValue(userData.login2);
  }

  data;
  editar({ rowData }) {
    console.log("EDITAR", rowData)
    this.data = rowData;

    this.commonFormService.abrirFormularioParaGuardar(this);

    this.formulario.setValue(rowData);
    this.textBoton = this.DAT_BTNS.guardar;
    this.tituloForm = 'Habilitar Periodo de Comisiones';

    if (rowData.vendedorId == null) {
      this.formulario.get("nombreVendedor").setValue('TODOS');
    }
  }

  acciones(event) {
    // debugger
    if (event === this.GUARDAR) {
      this.guardar();
    } else {
      this.limpiarRegresar();
    }
  }

  limpiarRegresar() {
    this.mostrarFormulario = false;
    this.tituloCard = 'Mantenedor Habilitar Periodo de Comisiones';
    this.tituloForm = 'Lista De Habilitar Periodo de Comisiones';
  }

  /** SERVICIOS */


  eliminar({ rowData }) {

    this._utils
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        // text: `${rowData.idValorFlete}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this._serviciosCRUD.deleteTipoDeVendedore(rowData.idTipo),
      })
      .then((res: any) => {
        this.getTiposDeVendedores();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });

  }

  guardar() {

    let datos = this.formulario.getRawValue();

    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: '',
        action: this.DAT_BTNS.guardar,
        funcion: this._serviciosCRUD.saveTipoDeVendedore(datos),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarRegresar();
      this.formulario.reset();
      this.getTiposDeVendedores();
    }).catch((err) => {
      console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  actualizar() {
    console.log("actualizar")

    console.log(this.formulario.getRawValue())
    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._serviciosCRUD.updateTipoDeVendedore(this.formulario.getRawValue()),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarRegresar();
      this.formulario.reset();
      this.getTiposDeVendedores();
      document.getElementById('cerrarModal').click();
    }).catch((err) => {
      console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  listTiposDeVendedores;
  getTiposDeVendedores() {
    this.loading = true;
    this._tipoDeVendedor.getTiposDeVendedoresPorEstado("1").subscribe((res: any[]) => {
      console.log("getTiposDeVendedores()", res)
      this.loading = false;
      this.listTiposDeVendedores = res;
    }, (err) => {
      this.loading = false;
      this.listTiposDeVendedores = [];
    });
  }

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
    console.log('formulario: ', this.formulario.getRawValue());
  }

  listVendedores;
  vendedores(tipoDeVendedor) {
    this.loading = true;
    this._altaDeVendedor.getTodoPorTipo(tipoDeVendedor).subscribe((res: any[]) => {
      console.log("getTiposDeVariables()", res)
      this.loading = false;
      this.listVendedores = res;

      for (let i = 0; i < this.listVendedores.length; i++) {
        this.listVendedores[i].nombreAMostrar = this.listVendedores[i].codigoSap + " - " + this.listVendedores[i].nombreVendedor1;
      }

      if (this.formulario.get("tipo")) {

      }
      this.listVendedores.unshift({
        nombreAMostrar: 'TODOS',
        vendedorId: 'todos',
      });

      this.formulario.get("vendedorId").setValue(this.data.vendedorId);

    }, (err) => {
      this.loading = false;
      this.listVendedores = [];

      this.listVendedores.unshift({
        nombreAMostrar: 'TODOS',
        vendedorId: 'todos',
      });

      this.formulario.get("vendedorId").setValue('todos');

    });
  }

  habilitarPeriodo() {

    this.loading = true;
    this._utils
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.actualizar,
        // text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._serviciosCRUD.habilitarPeriodo(this.formulario.getRawValue()),
      })
      .then((res: any) => {
        this.getTodo();
        this.limpiarRegresar();
        this.formulario.reset();
        console.log("habilitarPeriodo()", res)
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });

  }

}
